import { render, staticRenderFns } from "./AddDriverPage.vue?vue&type=template&id=6c28b9bb&scoped=true&"
import script from "./AddDriverPage.vue?vue&type=script&lang=js&"
export * from "./AddDriverPage.vue?vue&type=script&lang=js&"
import style0 from "./AddDriverPage.vue?vue&type=style&index=0&id=6c28b9bb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c28b9bb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VFlex } from 'vuetify/lib/components/VGrid';
import { VLayout } from 'vuetify/lib/components/VGrid';
installComponents(component, {VFlex,VLayout})
